<template>
	<div class="page_hear">
		<div class="hear_cont">
			<div class="logo">
				<img src="@/assets/img/logo.png" class="logo_" alt="smallfatman">
			</div>
			<div class="taps">
				<div class="taps_list hidden-xs-only">
					<div :class="['taps_item',nowPath==item.url?'taps_item_ed':'']" v-for="(item,index) in taps"
						:key="index">
						<a @click="toPage(item.url)">{{item.title}}</a>
					</div>
				</div>
				<div class="taps_menu hidden-sm-and-up">
					<el-dropdown trigger="click" @visible-change="handleChange" @command="toPage">
						<span class="el-dropdown-link">
							<i :class="showmenu?'el-icon-s-grid':'el-icon-menu'"
								:style="showmenu?'color: blue;':''"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :icon="item.icon" :command="item.url" v-for="(item,index) in taps"
								:key="index">{{item.title}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'hear',
		data() {
			return {
				taps: [{
						title: '站点首页',
						url: '/',
						icon: 'el-icon-house'
					},
					// {
					// 	title: '站内文章',
					// 	url: '/content',
					// 	icon: 'el-icon-notebook-2'
					// }, 
					{
						title: '关于站点',
						url: '/aboutit',
						icon: 'el-icon-connection'
					}
				],
				nowPath: '/',
				showmenu: false
			}
		},
		created() {
			this.nowPath = this.$store.state.nowPathUrl
		},
		methods: {
			toPage(link) {
				if (!link) return
				if (this.$store.state.nowPathUrl == link) return
				this.nowPath = link
				this.$router.push(link)
			},
			handleChange(e) {
				this.showmenu = e
			}
		}
	}
</script>

<style lang="less" scoped>
	.page_hear {
		height: 100%;

		.hear_cont {
			display: flex;
			padding: 10px 0 0 0;
			height: calc(100% - 10px);
			align-items: center;
			justify-content: space-between;

			.logo {
				height: 70px;
				display: flex;
				width: 80px;
				position: relative;
				align-items: center;
				overflow: hidden;

				.logo_ {
					position: absolute;
					left: 0;
					top: 0;
					width: 80px;
					height: 80px;
					background-color: #fafafa;
					border-radius: 40%;
				}
			}

			.taps {
				.taps_list {
					display: flex;
					align-items: center;

					.taps_item {
						margin-left: 40px;
						font-size: 14px;
						font-weight: bold;
					}

					.taps_item_ed {
						color: #343D4E;
						font-size: 15px;
					}
				}

				.el-dropdown-link {
					font-size: 30px;
				}
			}


		}
	}
</style>
